export enum newUserActionTypes {
    SAVE_BEGIN = "SAVE_BEGIN",
    SAVE_ERROR = "SAVE_ERROR",
    SAVE_SUCCESS = "SAVE_SUCCESS",

    CLEAN_DATA_NEW_USER = "CLEAN_DATA_NEW_USER"
}